import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
// Constants - Functions
import { WEB_SERVICE_MIMS } from "../../../../config/constants";
// Components
import { MainDiv } from "./styles";
import UseFetch from "../../../../config/useFetch";
import Loader from "../../../loader";
import Title from "../../../title";
import RecentWellBeingAssessment from "./sections/recentWellBeingAssessment";
import WellBeingAssessmentsPlot from "./sections/wellBeingAssessmentsPlot";

const WellBeingAssessment = () => {
  const [emotionalAnswersPerWeek, setEmotionalAnswerPerWeek] = useState([]);
  const [lastEmotionalAnswer, setLastEmotionalAnswer] = useState([]);
  const [isLoadingEmotionalAnswers, setIsLoadingEmotionalAnswers] = useState(true);
  const { patientId } = useParams();

  const getLastNonEmptyArray = (arrays) => {
    for (let i = arrays.length - 1; i >= 0; i--) {
      if (Array.isArray(arrays[i]) && arrays[i].length > 0) {
        return arrays[i];
      }
    }
    return [];
  };

  // Fetch Emotional Answers
  useEffect(() => {
    UseFetch("get", `${WEB_SERVICE_MIMS}/recsys/get-well-being-assessment/${patientId}`)
      .then(({ data }) => {
        setEmotionalAnswerPerWeek(data);
        setLastEmotionalAnswer(getLastNonEmptyArray(data));
        setIsLoadingEmotionalAnswers(false);
      })
      .catch((error) => {
        console.log("Get Emotional Answers data: ", error);
      });

    return () => {
      setEmotionalAnswerPerWeek([]);
      setLastEmotionalAnswer([]);
      setIsLoadingEmotionalAnswers(true);
    };
  }, [patientId]);

  return (
    <>
      <Title title={"SELF REPORTED WELL-BEING"} marginBottom="15px" />
      {isLoadingEmotionalAnswers ? (
        <Loader height={50} />
      ) : (
        <MainDiv>
          <RecentWellBeingAssessment lastEmotionalAnswer={lastEmotionalAnswer} />
          <WellBeingAssessmentsPlot isPositiveAnswers={false} emotionalAnswersPerWeek={emotionalAnswersPerWeek} />
          <WellBeingAssessmentsPlot isPositiveAnswers={true} emotionalAnswersPerWeek={emotionalAnswersPerWeek} />
        </MainDiv>
      )}
    </>
  );
};

export default WellBeingAssessment;
